import React, { useEffect, useState } from 'react'
import { Button, Modal, Pagination, Spin, Empty, Popover } from "antd"
import { PopoverBody, PopoverHeader, UncontrolledPopover } from "reactstrap"
import moment from 'moment'
import { ObjectInspector } from 'react-inspector'

const HistoryModal = (props) => {
    const { visible, toggleModal, idItem, api } = props
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState('')
    const [listHistories, setListHistories] = useState([])
    const [page, setPage] = useState(1)
    const [limit, setLimit] = useState(10)
    const [total, setTotal] = useState(0)

    const handlePageChange = (current) => {
        setPage(current)
    }

    const handleShowSizeChange = (current, size) => {
        setPage(1)
        setLimit(size)
    }

    const _fetchListHistory = async () => {
        setLoading(true)
        setError('')
        setListHistories([])

        try {
            const payload = {
                page: page,
                limit: limit
            }
            const { data: res } = await api(idItem, payload)
            const { data, success, message: error } = res
            if (!success) return setError(error)

            const { history, total } = data
            setListHistories(history)
            setTotal(total)
        } catch (e) {
            setError(e.message)
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        visible && _fetchListHistory()
    }, [visible, page, limit])

    return (
        <>
            <Modal
                className="HistoryModal"
                visible={visible}
                title="Lịch sử thay đổi"
                onCancel={toggleModal}
                footer={false}
                style={{ maxHeight: '800px', }}
                width={1200}
            >
                <div className='ContentModal'>
                    <Spin spinning={loading} tip="Loading...">
                        <div className='wrapTable' style={{ height: 550, overflow: 'auto' }}>
                            <table className="table">
                                <thead>
                                    <tr>
                                        <th className="colID">#</th>
                                        <th className="colTime">Thời gian</th>
                                        <th className="colDescription">Mô tả</th>
                                        <th className="colUser">Người tạo</th>
                                        <th className="colIP">IP</th>
                                        <th className="colMeta">Key</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        (listHistories && listHistories.length > 0) ? listHistories.map((history, index) => {
                                            const { _id, meta, created_at, description, user, event, user_ip } = history

                                            return (
                                                <tr key={_id}>
                                                    <td className="colID">{index + 1}</td>
                                                    <td className="colTime">{created_at ? moment(created_at).format('HH:mm DD/MM/YYYY') : '-'}</td>
                                                    <td className="colDescription" style={{ wordBreak: 'break-word' }}>{description || ''}</td>
                                                    <td className="colUser">{user || ''}</td>
                                                    <td className="colIP">{user_ip || '--'}</td>
                                                    <td className="colMeta">
                                                        <Popover
                                                            title={<code>{event}</code>}
                                                            content={
                                                                <ObjectInspector
                                                                    depth={0}
                                                                    path="root.value"
                                                                    data={meta !== undefined ? (Object.keys(meta).length === 0 ? '--' : meta) : '--'}
                                                                />
                                                            }
                                                            placement='leftBottom'
                                                            overlayClassName="event-key-popover"
                                                            overlayStyle={{ width: '500px !important' }}
                                                            trigger="click"
                                                        >
                                                            <span id={`mypopover_${index}_${_id}`} color="link" className='cursor-pointer'>
                                                                <code>{event}</code>
                                                            </span>
                                                        </Popover>
                                                    </td>
                                                </tr>
                                            )
                                        }) :
                                            <tr>
                                                <td colSpan={6}>
                                                    <Empty description='Không có lịch sử' imageStyle={{ height: 200 }} />
                                                </td>
                                            </tr>
                                    }

                                    {
                                        error && error.length > 0 && <tr>
                                            <td colSpan={6} className="text-danger">{error}</td>
                                        </tr>
                                    }
                                </tbody>
                            </table>
                        </div>
                    </Spin>
                    <div className="OrdersPagination d-flex justify-content-end Pagination">
                        <Pagination
                            current={page}
                            total={total}
                            pageSize={limit}
                            onChange={handlePageChange}
                            className='text-right'
                            showSizeChanger
                            pageSizeOptions={['10', '20', '50', '100']}
                            onShowSizeChange={handleShowSizeChange}
                        />
                    </div>
                </div>
            </Modal >
        </>
    )
}

export default HistoryModal